
import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const Item = styled('div')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const SpacedItem = ({ children }) => (
  <Item>{children}</Item>
);
  
SpacedItem.propTypes = {
  children: PropTypes.node
};

export default SpacedItem;